import React from 'react';
import { Avatar, View } from '@zonofi/seller-hub';
import {
  getUserData,
  useAppSelector,
  Workspace,
} from '@zonofi/zono-money-store';

export interface CurrentWorkspaceCardProps {
  workspace: Workspace | null;
  isCurrent?: boolean;
}

export const CurrentWorkspaceCard: React.FC<CurrentWorkspaceCardProps> = ({
  workspace,
  isCurrent = true,
}) => {
  const userData = useAppSelector(getUserData);

  if (!workspace) return null;

  const title = isCurrent ? userData.firstName : workspace.spaceName;

  const subtitle = isCurrent
    ? `+${userData.mobile} • ${workspace.spaceName}`
    : workspace.code;

  return (
    <div className="side-drawer-header--left">
      <Avatar
        profileUrl={workspace.profilePic}
        id={workspace.id}
        title={title}
        size={40}
      />
      <View>
        <span className="side-drawer-header--text font-semibold">{title}</span>
        <span className="side-drawer-header--subtext font-regular">
          {subtitle}
        </span>
      </View>
    </div>
  );
};
